import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "MainPagePc"
}
const _hoisted_2 = { style: {"display":"flex","justify-content":"center","width":"100%"} }
const _hoisted_3 = { style: {"display":"flex","justify-content":"center","width":"1440px"} }
const _hoisted_4 = { class: "left-info" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "right-info" }
const _hoisted_7 = { class: "image-row" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  class: "message-box",
  ref: "messageBox"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 0,
  class: "bottom-message-box"
}
const _hoisted_12 = { class: "information-box" }
const _hoisted_13 = {
  class: "sub-row",
  style: {"margin-top":"8px"}
}
const _hoisted_14 = { style: {"font-weight":"500"} }
const _hoisted_15 = { class: "sub-row" }
const _hoisted_16 = { style: {"font-weight":"500"} }
const _hoisted_17 = { class: "sub-row" }
const _hoisted_18 = { style: {"font-weight":"500"} }
const _hoisted_19 = { class: "sub-row" }
const _hoisted_20 = { style: {"font-weight":"500"} }
const _hoisted_21 = { class: "sub-row" }
const _hoisted_22 = { style: {"font-weight":"500"} }
const _hoisted_23 = { class: "greetings-header" }
const _hoisted_24 = { class: "guest-message" }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = {
  key: 1,
  class: "MainPageMobile"
}
const _hoisted_27 = { style: {"display":"flex","flex-direction":"column","align-items":"center","justify-content":"center"} }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "top-information" }
const _hoisted_30 = { class: "title" }
const _hoisted_31 = {
  key: 0,
  class: "bottom-message-box"
}
const _hoisted_32 = { class: "sub-row" }
const _hoisted_33 = { class: "sub-row" }
const _hoisted_34 = { class: "sub-row" }
const _hoisted_35 = { class: "sub-row" }
const _hoisted_36 = { class: "sub-row" }
const _hoisted_37 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FloatingBottomBar = _resolveComponent("FloatingBottomBar")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isMobile == false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[23] || (_cache[23] = _createElementVNode("h3", { style: {"margin-top":"29px"} }, "Reservation update", -1)),
          _createElementVNode("h4", null, _toDisplayString(_ctx.hotelName), 1),
          _cache[24] || (_cache[24] = _createElementVNode("div", { style: {"width":"100%","height":"1px","background":"rgba(34, 34, 34, 0.1)","margin-top":"16px"} }, null, -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "title" }, "Welcome,", -1)),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.mainGuestName), 1),
                _cache[12] || (_cache[12] = _createElementVNode("body", { style: {"width":"400px","margin":"25px 0 42px 0 !important"} }, " When you Continue you’ll find a list of all the reservations for your upcoming stay. Let us know who’s coming and make the stay smooth for everyone. ", -1)),
                _createElementVNode("div", {
                  class: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.continueToNextPage()))
                }, [...(_cache[10] || (_cache[10] = [
                  _createTextVNode(" Continue ", -1),
                  _createElementVNode("img", {
                    width: "24",
                    height: "24",
                    src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Navigation/arrow_1_5px/right.png"
                  }, null, -1)
                ]))])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("img", {
                    src: _ctx.hotelImage,
                    style: {"object-fit":"cover","object-position":"center"}
                  }, null, 8, _hoisted_8),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[14] || (_cache[14] = _createElementVNode("h3", { style: {"margin-bottom":"8px"} }, "Greetings from the hotel", -1)),
                    _createElementVNode("body", {
                      style: {"width":"100%"},
                      innerHTML: _ctx.messageToGroup
                    }, null, 8, _hoisted_10),
                    (_ctx.isOverflowing)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("div", {
                            class: "read-all",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showFullGreeting = true))
                          }, [...(_cache[13] || (_cache[13] = [
                            _createElementVNode("u", null, "Read all", -1),
                            _createElementVNode("img", { src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Navigation/arrow_1_5px/right.png" }, null, -1)
                          ]))])
                        ]))
                      : _createCommentVNode("", true)
                  ], 512)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[20] || (_cache[20] = _createElementVNode("h3", null, "Information", -1)),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[15] || (_cache[15] = _createElementVNode("body", null, " Reservation owner ", -1)),
                    _createElementVNode("body", _hoisted_14, _toDisplayString(_ctx.mainGuestName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _cache[16] || (_cache[16] = _createElementVNode("body", null, " Email ", -1)),
                    _createElementVNode("body", _hoisted_16, _toDisplayString(_ctx.mainGuestEmail), 1)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _cache[17] || (_cache[17] = _createElementVNode("body", null, " Phone number ", -1)),
                    _createElementVNode("body", _hoisted_18, _toDisplayString(_ctx.mainGuestPhone), 1)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _cache[18] || (_cache[18] = _createElementVNode("body", null, " Number of reservations ", -1)),
                    _createElementVNode("body", _hoisted_20, _toDisplayString(_ctx.numberOfReservations), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _cache[19] || (_cache[19] = _createElementVNode("body", null, " Complete before ", -1)),
                    _createElementVNode("body", _hoisted_22, _toDisplayString(_ctx.expireDate), 1)
                  ])
                ])
              ])
            ])
          ]),
          (_ctx.showFullGreeting)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showFullGreeting = false)),
                style: {"width":"100%","height":"100%","display":"flex","align-items":"center","justify-content":"center","position":"absolute","z-index":"100","top":"0","left":"0","background":"linear-gradient(180deg, rgba(34, 34, 34, 0.35) 0%, rgba(34, 34, 34, 0.35) 100%)","backdrop-filter":"blur(2px)"}
              }, [
                _createElementVNode("div", {
                  class: "greetings-full-box",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_23, [
                    _cache[21] || (_cache[21] = _createElementVNode("div", { style: {"width":"16px","height":"16px"} }, null, -1)),
                    _cache[22] || (_cache[22] = _createElementVNode("h5", null, "Greetings from the hotel", -1)),
                    _createElementVNode("img", {
                      src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Navigation/cross.svg",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFullGreeting = false))
                    })
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("body", { innerHTML: _ctx.messageToGroup }, null, 8, _hoisted_25)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isMobile == true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("div", {
            style: _normalizeStyle([{ width: _ctx.windowWidth + 'px' }, {"position":"fixed","z-index":"100","top":"0","left":"0","height":"31px","display":"flex","justify-content":"center","align-items":"center","padding":"16px","border-bottom":"2px solid #dfdfdf","background":"#fafafa"}])
          }, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.hotelName), 1),
              _cache[25] || (_cache[25] = _createElementVNode("h5", null, "Reservation update", -1))
            ])
          ], 4),
          _createVNode(_component_FloatingBottomBar, {
            headerText: 'Continue',
            withArrow: true,
            bodyText: '',
            active: true,
            isMobile: true,
            onUpdateConfirm: _cache[5] || (_cache[5] = ($event: any) => (_ctx.continueToNextPage()))
          }),
          _createElementVNode("img", {
            src: _ctx.hotelImage,
            style: {"width":"100%","height":"164px","object-fit":"cover","object-position":"center"}
          }, null, 8, _hoisted_28),
          _createElementVNode("div", {
            style: _normalizeStyle([{ width: parseInt(_ctx.windowWidth) - 12 + 'px' }, {"display":"flex","justify-content":"center","flex-direction":"column","align-items":"center","gap":"16px","padding":"16px"}])
          }, [
            _createElementVNode("div", _hoisted_29, [
              _cache[26] || (_cache[26] = _createElementVNode("div", { class: "title" }, "Welcome,", -1)),
              _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.mainGuestName), 1),
              _cache[27] || (_cache[27] = _createElementVNode("body", { style: {"margin-top":"8px"} }, [
                _createTextVNode(" When you "),
                _createElementVNode("b", null, "Continue"),
                _createTextVNode(" you’ll find a list of all the reservations for your upcoming stay. Let us know who’s coming and make the stay smooth for everyone. ")
              ], -1))
            ]),
            _createElementVNode("div", {
              class: "greetings-box",
              style: _normalizeStyle({ width: _ctx.windowWidth + 'px' }),
              ref: "messageBoxMobile"
            }, [
              _cache[29] || (_cache[29] = _createElementVNode("h3", null, "Greetings from the hotel", -1)),
              _createElementVNode("body", {
                style: _normalizeStyle([{ width: parseInt(_ctx.windowWidth) - 48 + 'px' }, {"max-height":"143px","height":"fit-content","padding":"24px"}])
              }, _toDisplayString(_ctx.messageToGroup), 5),
              (_ctx.isOverflowingMobile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("div", {
                      class: "read-all",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showFullGreeting = true))
                    }, [...(_cache[28] || (_cache[28] = [
                      _createElementVNode("u", null, "Read all", -1),
                      _createElementVNode("img", { src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Navigation/arrow_1_5px/right.png" }, null, -1)
                    ]))])
                  ]))
                : _createCommentVNode("", true)
            ], 4),
            _createElementVNode("div", {
              class: "group-info-box",
              style: _normalizeStyle({ width: _ctx.windowWidth + 'px' })
            }, [
              _cache[35] || (_cache[35] = _createElementVNode("h3", { style: {"margin-bottom":"16px"} }, "Group information", -1)),
              _createElementVNode("div", _hoisted_32, [
                _cache[30] || (_cache[30] = _createElementVNode("body", null, " Reservation owner ", -1)),
                _createElementVNode("b", null, _toDisplayString(_ctx.mainGuestName), 1)
              ]),
              _createElementVNode("div", _hoisted_33, [
                _cache[31] || (_cache[31] = _createElementVNode("body", null, " Email ", -1)),
                _createElementVNode("b", null, _toDisplayString(_ctx.mainGuestEmail), 1)
              ]),
              _createElementVNode("div", _hoisted_34, [
                _cache[32] || (_cache[32] = _createElementVNode("body", null, " Phone number ", -1)),
                _createElementVNode("b", null, _toDisplayString(_ctx.mainGuestPhone), 1)
              ]),
              _createElementVNode("div", _hoisted_35, [
                _cache[33] || (_cache[33] = _createElementVNode("body", null, " number of reservations ", -1)),
                _createElementVNode("b", null, _toDisplayString(_ctx.numberOfReservations), 1)
              ]),
              _createElementVNode("div", _hoisted_36, [
                _cache[34] || (_cache[34] = _createElementVNode("body", null, " Complete before ", -1)),
                _createElementVNode("b", null, _toDisplayString(_ctx.expireDate), 1)
              ])
            ], 4)
          ], 4),
          (_ctx.showFullGreeting)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showFullGreeting = false)),
                style: {"width":"100%","height":"100%","display":"flex","align-items":"center","justify-content":"center","position":"absolute","z-index":"100","top":"0","left":"0","background":"linear-gradient(180deg, rgba(34, 34, 34, 0.35) 0%, rgba(34, 34, 34, 0.35) 100%)","backdrop-filter":"blur(2px)"}
              }, [
                _createElementVNode("div", {
                  class: "greetings-full-box",
                  onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", {
                    class: "greetings-header",
                    style: _normalizeStyle({ width: _ctx.windowWidth + 'px' })
                  }, [
                    _cache[36] || (_cache[36] = _createElementVNode("div", { style: {"width":"16px","height":"16px"} }, null, -1)),
                    _cache[37] || (_cache[37] = _createElementVNode("b", null, "Greetings from the hotel", -1)),
                    _createElementVNode("img", {
                      src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Navigation/cross.svg",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showFullGreeting = false))
                    })
                  ], 4),
                  _createElementVNode("div", {
                    class: "guest-message",
                    style: _normalizeStyle({ width: parseInt(_ctx.windowWidth) - 16 + 'px' })
                  }, [
                    _createElementVNode("body", { innerHTML: _ctx.messageToGroup }, null, 8, _hoisted_37)
                  ], 4)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}